<template>
  <div class="report-section report-section-chart">
    <h2 class="report-section-heading">Total vs pago</h2>
    <div class="card report-chart-card">
      <div class="report-chart-inner">
        <apexchart
          width="100%"
          type="bar"
          :series="series"
          :options="chartOptions"
        />
      </div>
    </div>
  </div>
</template>

<script>
import VueApexCharts from 'vue3-apexcharts';

export default {
  name: 'ReportChart',
  components: { apexchart: VueApexCharts },
  props: {
    series: {
      type: Array,
      required: true
    },
    chartOptions: {
      type: Object,
      required: true
    }
  }
};
</script>

<style scoped>
.report-section {
  margin-bottom: var(--space-xl);
}

.report-section-chart {
  max-width: 100%;
}

.report-section-heading {
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: var(--color-text-secondary);
  margin: 0 0 var(--space-sm);
}

.report-chart-card {
  padding: 0px;
  display: block;
}

.report-chart-inner {
  width: 100%;
}
</style>
